module.exports = __webpack_public_path__ + "static/media/fast-charging.799a046c.jpeg";